import { useState } from 'react';
import { Modal } from '@/primer/components';

/** Persists whether the creator has dismissed the "slow down" tip for good. */
export const RESERVATION_SLOW_DOWN_DISMISSED_KEY = 'reservation-slow-down-dismissed';

function getSlowDownDismissed(): boolean {
  try {
    return sessionStorage.getItem(RESERVATION_SLOW_DOWN_DISMISSED_KEY) === 'true';
  } catch {
    return false;
  }
}

function persistSlowDownDismissed(): void {
  try {
    sessionStorage.setItem(RESERVATION_SLOW_DOWN_DISMISSED_KEY, 'true');
  } catch {
    // Ignore storage write failures (private/incognito mode) and keep UX functional.
  }
}

/** One-time "slow down" tip shown the first time a product is reserved. */
export function ReservationSlowDownModal() {
  const [isOpen, setIsOpen] = useState(() => !getSlowDownDismissed());

  const dismiss = (doNotShowAgain?: boolean) => {
    if (doNotShowAgain) persistSlowDownDismissed();
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      icon="circle-info-filled"
      title="You can slow down now"
      description="Product(s) are reserved until the timer runs out. Please take your time to review the program's requirements."
      showDoNotShowAgain
      primaryButton={{ label: 'Got it', onClick: dismiss }}
    />
  );
}
